import React from "react";
import FeatureGridSection3 from "./FeatureGridSection3";

export default function PricingSection() {
  return <FeatureGridSection3 />;
}

